import 'nprogress/nprogress.css';

import { Message } from 'element-ui';
import NProgress from 'nprogress';
import { Route } from 'vue-router';

import router from './router';
import store from './store';

const whitelist = ['/login'];

router.beforeEach(async (to: Route, from: Route, next: any) => {
  NProgress.start();
  if (store && store.state && store.state.user && store.state.user.jwt) {
    if (to.path === '/login') {
      next({ path: '/' });
      NProgress.done(); // If current page is dashboard will not trigger afterEach hook, so manually handle it
    } else {
      await store.dispatch('user/loadRoles');
      if (to.meta.roles && !store.state.user.roles.some(p => to.meta.roles.includes(p))) {
        Message.error('Verification failed, please login again');
        store.commit('user/setJwt', '');
        next({ path: '/' });
        NProgress.done();
      } else {
        next();
      }
    }
  } else {
    if (whitelist.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`); // Redirect to login page
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
